"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreeLowestPriceProductPromotionPropertiesSchema = exports.FreeLowestPriceWithXPriceInTotalOfSelectedProductInBundleProductPromotionSettingSchema = exports.FreeLowestPriceWithXPieceOfSelectedProductInBundleProductPromotionSettingSchema = void 0;
const zod_1 = require("zod");
const typings_1 = require("../../../typings");
const base_1 = require("../base");
const BaseFreeLowestPricePromotionSettingsSchema = base_1.PromotionSettingsSchema.extend({
    type: (0, base_1.isValueMatchedSchema)(zod_1.z.string(), typings_1.PromotionSettingsType.FREE_LOWEST_PRICE),
    threshold: (0, base_1.OptionalAndNullishSchema)(zod_1.z.union([base_1.PromotionAmountThresholdSchema, (0, base_1.OptionalAndNullishSchema)(base_1.PromotionPriceThresholdSchema)])),
    freeProducts: (0, base_1.OptionalAndNullishSchema)(zod_1.z.array(base_1.FreeProductSchema)),
});
exports.FreeLowestPriceWithXPieceOfSelectedProductInBundleProductPromotionSettingSchema = BaseFreeLowestPricePromotionSettingsSchema.extend({
    condition: (0, base_1.isValueMatchedSchema)(zod_1.z.string(), typings_1.PromotionCondition.BUY_X_PIECE_OF_SELECTED_PRODUCT_IN_BUNDLE),
    criteria: zod_1.z.array(base_1.PromotionCriteriaSchema.extend({
        thresholds: zod_1.z.array(base_1.PromotionAmountThresholdSchema),
        freeProducts: zod_1.z.array(base_1.FreeProductSchema),
    })),
    isBundled: (0, base_1.isValueMatchedSchema)(zod_1.z.boolean(), true),
});
exports.FreeLowestPriceWithXPriceInTotalOfSelectedProductInBundleProductPromotionSettingSchema = BaseFreeLowestPricePromotionSettingsSchema.extend({
    condition: (0, base_1.isValueMatchedSchema)(zod_1.z.string(), typings_1.PromotionCondition.BUY_X_PRICE_IN_TOTAL_OF_SELECTED_PRODUCT_IN_BUNDLE),
    criteria: zod_1.z.array(base_1.PromotionCriteriaSchema.extend({
        thresholds: zod_1.z.array(base_1.PromotionPriceThresholdSchema),
        freeProducts: zod_1.z.array(base_1.FreeProductSchema),
    })),
    isBundled: (0, base_1.isValueMatchedSchema)(zod_1.z.boolean(), true),
});
exports.FreeLowestPriceProductPromotionPropertiesSchema = (0, base_1.generatePromotionPropertiesSchemaByPromotionTypeAndItsSettingsSchema)(typings_1.PromotionType.PRODUCT, zod_1.z.union([
    exports.FreeLowestPriceWithXPieceOfSelectedProductInBundleProductPromotionSettingSchema,
    exports.FreeLowestPriceWithXPriceInTotalOfSelectedProductInBundleProductPromotionSettingSchema,
]));
//# sourceMappingURL=free-lowest-price.js.map